import { action, makeObservable, onBecomeObserved } from "mobx"

import GlobalProjectsCollection from "@src/app/ProjectsCollection"
import { catchErrors, whitelistDomainsApi } from "@src/shared/api"
import { Pagination } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"

export type Domain = {
  created_at: string
  id: string
  project_id: string
  updated_at: string
  url: string
}

export type DomainsCollectionLoadRequest = {
  page?: number
}

export type CreateRequest = {
  project_id?: string
  url?: string
}

export class DomainsCollection extends loading(
  ["fetch", "delete", "create"],
  CollectionWithPagination<Domain>,
) {
  constructor(public projects = GlobalProjectsCollection()) {
    super()

    makeObservable(this, {
      fetch: action.bound,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }
  async create(data: CreateRequest) {
    return await whitelistDomainsApi
      .createWhitelistDomain(data)
      .catch(catchErrors)
      .then(this.load)
  }

  async delete(id: string) {
    return whitelistDomainsApi
      .deleteWhitelistDomain(id)
      .catch(catchErrors)
      .then(this.load)
  }

  async fetch(req: DomainsCollectionLoadRequest) {
    try {
      const { data: { data } = {} } =
        await whitelistDomainsApi.listWhitelistDomains(
          undefined,
          this.calcOffset(req.page),
          this.pageSize,
        )

      if (data) {
        const { domains, pagination } = data as {
          domains: Domain[]
          pagination: Pagination
        }

        return {
          data: domains,
          pagination,
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }
}
